import loadable from '@loadable/component'
import React from 'react'
import sw from '@uswitch/ev-utils/switch'
import { getVariantPath } from '@uswitch/ev-utils/get-variant-path'
import withComponentBase from '../../helpers/with-component-base'

export const categoryGuidesStylePath = (field, variant) =>
  getVariantPath({
    atomicType: 'modules',
    componentId: 'categoryGuide',
    variantName: variant,
    field,
  })

const Default = loadable(() => import('./default'))
const HtmlSitemap = loadable(() => import('./html-sitemap'))

const CategoryGuides = props =>
  sw({
    'html-sitemap': () => <HtmlSitemap {...props} />,
    default: () => <Default {...props} />,
  })(props.variant, props)

export default withComponentBase(CategoryGuides, {
  withHeaderFooter: true,
  headerStyles: { h3: { color: 'dark-2' } },
})
